import React, { useEffect, useMemo } from "react";

export interface UseContentHeightOptions {
  offset?: number;
  useWindowHeight?: boolean;
  deps?: unknown[];
}

export const useContentHeight = (
  contentRef: React.MutableRefObject<HTMLElement | null>,
  siblingRefs: Array<React.MutableRefObject<HTMLElement | null>>,
  options?: UseContentHeightOptions
): void => {
  const { offset, useWindowHeight, deps } = options || {
    offset: 0,
    useWindowHeight: false,
    deps: [],
  };

  const depsString = useMemo(() => JSON.stringify(deps), [deps]);

  useEffect(() => {
    const content = contentRef.current;
    const siblingsHeight = siblingRefs.reduce((acc, ref) => {
      const sibling = ref.current;

      if (sibling) {
        const siblingHeight = sibling.getBoundingClientRect().height;
        acc += siblingHeight;
      }

      return acc;
    }, 0);

    if (content) {
      content.style.height = `calc(100${useWindowHeight ? "vh" : "%"} - ${siblingsHeight + offset}px)`;
    }
  }, [siblingRefs, offset, useWindowHeight, depsString]);
};
